export default function registerSellerOnboarding(Alpine) {
  Alpine.data("sellerOnboarding", (config) => ({
    steps: [],
    step: "",
    submitAction: config.submitAction,
    form: {},

    init() {
      this.steps = [...config.steps, { id: "review" }, { id: "final-form" }];

      // honor an incoming step from the URL, else start at the beginning
      const fromHash = window.location.hash.slice(1);
      const valid = this.steps.some((s) => s.id === fromHash);
      this.step = valid ? fromHash : this.steps[0].id;

      history.replaceState({ step: this.step }, "", "#" + this.step);
      window.addEventListener("popstate", (e) => {
        if (e.state?.step) this.step = e.state.step;
      });
    },

    get stepIndex() {
      return this.steps.findIndex((s) => s.id === this.step);
    },
    get totalSteps() {
      return this.steps.length;
    },
    get current() {
      return this.steps[this.stepIndex];
    },
    get progress() {
      return ((this.stepIndex + 1) / this.totalSteps) * 100;
    },
    get isLastStep() {
      return this.stepIndex === this.steps.length - 1;
    },
    get isFinalFormValid() {
      return this.form.full_name && this.form.email && this.form.phone;
    },

    goTo(id) {
      this.step = id;
      history.pushState({ step: id }, "", "#" + id);
    },
    next() {
      const i = this.stepIndex;
      if (i < this.steps.length - 1) this.goTo(this.steps[i + 1].id);
    },
    back() {
      history.back();
    },

    choose(value) {
      this.form[this.current.field] = value;
      this.next();
    },
    continueInput() {
      if (this.current.required && !this.form[this.current.field]) return;
      this.next();
    },
  }));
}
